import { PageLocatorMap } from '../types/PageLocatorMap';

export const coapplicantPreviousEmploymentPage = {
  alert: {
    error: 'coapplicant-previous-employment-page.form.alert.error',
  },
  footer: {
    root: 'coapplicant-previous-employment-page.footer.root',
  },
  form: {
    employerNameInput:
      'coapplicant-previous-employment-page.form.employer-name-input',
    employerNameInputError:
      'coapplicant-previous-employment-page.form.employer-name-input-error',
    employmentTypeSelect:
      'coapplicant-previous-employment-page.form.employment-type-select',
    employmentTypeSelectError:
      'coapplicant-previous-employment-page.form.employment-type-select-error',
    grossAnnualIncomeInput:
      'coapplicant-previous-employment-page.form.gross-annual-income-input',
    grossAnnualIncomeInputError:
      'coapplicant-previous-employment-page.form.gross-annual-income-input-error',
    h1: 'coapplicant-previous-employment-page.form.h1',
    h2: 'coapplicant-previous-employment-page.form.h2',
    incomeDisclosure:
      'coapplicant-previous-employment-page.form.income-disclosure',
    jobTitleInput: 'coapplicant-previous-employment-page.form.job-title-input',
    jobTitleInputError:
      'coapplicant-previous-employment-page.form.job-title-input-error',
    root: 'coapplicant-previous-employment-page.form.root',
    submitButton: 'coapplicant-previous-employment-page.form.submit-button',
  },
} as const satisfies PageLocatorMap;
